<template>
  <div>
    <div class="subtitle-2 font-weight-medium text-uppercase mb-3">Theme</div>
    <v-radio-group v-model="themeInput" class="mt-0">
      <v-radio label="Light" value="Light"></v-radio>
      <v-radio label="Dark" value="Dark"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Theme',
  computed: {
    ...mapState('cellwiseDowntimeDashboard', ['theme']),
    queries() {
      return this.$route.query;
    },
    themeInput: {
      get() {
        const queryTheme = this.$route.query.theme;
        if (queryTheme === 'dark') {
          return 'Dark';
        }
        if (queryTheme === 'light') {
          return 'Light';
        }
        return this.theme && this.theme.isDark ? 'Dark' : 'Light';
      },
      set(val) {
        const isDark = val === 'Dark';
        const themeValue = isDark ? 'dark' : 'light';
        this.$vuetify.theme.dark = isDark;
        const updatedTheme = { ...this.theme, isDark };
        const query = {
          ...this.queries,
          theme: themeValue,
        };

        if (this.$route.query.theme !== themeValue) {
          this.$router.replace({ query }).catch(() => {});
        }

        this.setTheme(updatedTheme);
      },
    },
  },
  methods: {
    ...mapMutations('cellwiseDowntimeDashboard', ['setTheme']),
  },
};
</script>
